import React, { useState, useEffect, useRef, useMemo } from 'react';
import { CButton, CBadge, CModal, CModalHeader, CTooltip, CModalTitle, CModalBody, CModalFooter, CSpinner, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { Link } from 'react-router-dom';
import { ProjectRepository } from 'src/repositories/projectRepository';
import { OrgRepository } from 'src/repositories/orgRepository';
import { cilPencil, cilCloudUpload, cilBan, cilActionUndo, cilQrCode, cilDataTransferUp, cilTrash } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { useKeycloak } from "@react-keycloak/web";
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { tablePaginationClasses } from '@mui/material/TablePagination';
import { tableSortLabelClasses } from '@mui/material/TableSortLabel';

import { MuiTableHead, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, TableSortLabel } from '@mui/material';
import ellipsis from '../../assets/images/ellipsis-vertical-solid.svg';
import excelIcon from '../../assets/images/file-excel-regular.svg';
import { toast } from 'react-toastify';
import shortid from 'shortid';
import Registration from './registration';
import deployIcon from '../../assets/images/deploy-svgrepo-com.svg';
import { GrDeploy } from "react-icons/gr";
import { IoEllipsisVerticalSharp } from "react-icons/io5";
import { PiExportBold } from "react-icons/pi";
import { styled } from '@mui/material/styles';
import { realm } from 'src/Keycloak';
import { FaCaretDown } from "react-icons/fa";
import { useHasRole, ROLES } from 'src/helpers/keycloakUtils';

const getBadge = status => {
    switch (status?.toLowerCase()) {
        case 'draft': return 'warning';  // Yellow, for attention but not critical
        case 'deployed': return 'success';  // Green, for successful operations
        case 'disabled': return 'danger';  // Red, for alerts and errors
        case 'deploying': return 'info';  // Blue, for ongoing processes
        case 'undeployed': return 'secondary';  // Grey, neutral for unused or default status
        case 'closed': return 'danger';  // Red, for alerts and errors
        default: return 'light';  // Light grey, for less critical or undefined statuses
    }
}

const formatFailureTooltip = (failureReason) => {
    if (!failureReason || !failureReason.startsWith('OPTION_CHAR_LIMIT')) {
        return "Project deployment failed.";
    }

    // Capture patterns:
    const match = failureReason.match(/Option '(.*?)' exceeds limit in (.*)/) || 
                  failureReason.match(/Option exceeds limit in (.*?) \('(.*?)'/);

    let optionText = "Unknown", languages = "Unknown";

    if (match) {
        if (failureReason.includes("Option exceeds limit in")) {
            languages = match[1];
            optionText = match[2];
        } else {
            optionText = match[1];
            languages = match[2].replace(/\.$/, ''); // Remove trailing dot
        }
    }

    return (
        <div style={{
            padding: '8px 10px',
            fontSize: '11px',
            lineHeight: '1.4',
            maxWidth: '250px',
            borderRadius: '6px',
            backgroundColor: '#1c1c1c',
            color: '#eee',
            boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
        }}>
            <div style={{
                fontWeight: '700',
                marginBottom: '6px',
                color: '#FFB300',
                fontSize: '12px'
            }}>
                Character Limit Exceeded
            </div>

            <div style={{ marginBottom: '2px' }}>
                <span style={{ color: '#888', fontWeight: '600' }}>Option:</span> "{optionText}"
            </div>

            <div style={{ marginBottom: '8px' }}>
                <span style={{ color: '#888', fontWeight: '600' }}>Langs:</span> {languages}
            </div>

            <div style={{
                fontSize: '10px',
                color: '#FFB300',
                borderTop: '1px solid rgba(255, 179, 0, 0.2)',
                paddingTop: '4px',
                fontStyle: 'italic'
            }}>
                English limit is 15, others are 22. Please update the questions to proceed.
            </div>
        </div>
    );
}

const DataCollectorComponent = () => {

    const [visible, setVisible] = useState(false);

    const [deployModal, setdeployModal] = useState(false);

    const [noQuesModal, setnoQuesModal] = useState(false);

    const [deleteModal, setDeleteModal] = useState(false);

    const [ViewModal, setViewModal] = useState(false);

    const [disableModal, setdisableModal] = useState(false);

    const [undeployModal, setundeployModal] = useState(false);

    const [QRModal, setQRModal] = useState(false);

    const [exportModal, setExportModal] = useState(false);

    const [QRCode, setQRCode] = useState(null);

    const [signedQRCode, setSignedQRCode] = useState(null);

    const [projectData, setProjectData] = useState([]);

    const [currentProject, setCurrentProject] = useState(null);

    const [currentProjectId, setCurrentProjectId] = useState(null);

    const [isLoading, setIsLoading] = useState(true);

    const [createModal, setCreateModal] = useState(false);

    const [orgName, setOrgName] = useState("Your");

    const [subOrganizations, setSubOrganizations] = useState([]);

    const [selectedOrg, setSelectedOrg] = useState('all');

    const [QRCodeText, setQRCodeText] = useState("");
    const [linkCopied, setLinkCopied] = useState(false);

    const outerTheme = useTheme();

    const navigate = useNavigate();

    const { keycloak } = useKeycloak();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const regPage = useRef();
    const [modalTitle, setModalTitle] = useState(null);
    const [modalMessage, setModalMessage] = useState(null);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('updatedAt');
    const isSuperAdmin = useHasRole(ROLES.ORG_ADMIN);
    const isAssessmentManager = useHasRole(ROLES.ORG_SURVEY_ANALYST);
    const isProjectManager = useHasRole(ROLES.ORG_SURVEY_LEAD);
    const isEnablerSuperAdmin = useHasRole(ROLES.ORG_ENABLER_SUPER_ADMIN);
    const isOrgViewer = useHasRole(ROLES.ORG_VIEWER);


    const isCreateButtonDisabled = !(isSuperAdmin || isProjectManager || isEnablerSuperAdmin) || (isEnablerSuperAdmin && selectedOrg && selectedOrg !== realm);

    const isActionDisabledMemo = useMemo(() => {
        const cache = new Map();
        return (project) => {
            if (cache.has(project.project_id)) {
                return cache.get(project.project_id);
            }
            let result = false;
            if (isEnablerSuperAdmin) {
                const orgIdFromProject = project.group_name;
                if (realm !== orgIdFromProject) {
                    result = true;
                } else if (selectedOrg && selectedOrg !== realm && selectedOrg !== 'all') {
                    result = true;
                }
            }
            cache.set(project.project_id, result);
            return result;
        };
    }, [isEnablerSuperAdmin, selectedOrg, realm]);

    const handleIconClick = (action, project) => {
        if (isActionDisabledMemo(project)) {
            notify(`You don't have access to ${action} this project`);
            return;
        }

        switch (action) {
            case 'undeploy':
                setundeployModal(!undeployModal);
                setCurrentProjectId(project.project_id);
                break;
            case 'export':
                setExportModal(!exportModal);
                setCurrentProjectId(project.project_id);
                break;
            case 'delete':
                setDeleteModal(!deleteModal);
                setCurrentProjectId(project.project_id);
                break;
            case 'close':
                setdisableModal(!disableModal);
                setCurrentProjectId(project.project_id);
                break;
            case 'edit':
                setVisible(!visible);
                setCurrentProjectId(project.project_id);
                break;
            case 'deploy':
                setdeployModal(!deployModal);
                setCurrentProjectId(project.project_id);
                break;
            case 'showQRCode':
                setQRModal(!QRModal);
                setQRCodeText(project.qr_code_text);
                setQRCode(project.qr_code_url);
                QrCallback(project.qr_code_url);
                setCurrentProjectId(project.project_id);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        let intervalId;
        let timeoutId;

        // Fallback timeout to ensure loading doesn't get stuck
        timeoutId = setTimeout(() => {
            console.log('Loading timeout reached, forcing isLoading to false');
            setIsLoading(false);
        }, 10000); // 10 seconds timeout

        const fetchData = async () => {
            try {
                console.log('Initial data fetch started, isLoading: ', isLoading);
                if (isEnablerSuperAdmin) {
                    const response = await OrgRepository.getSubOrganizations(realm);
                    const subOrgs = response.data;
                    setSubOrganizations(subOrgs);

                    if (selectedOrg === 'all') {
                        const orgIdArray = subOrgs.map(org => org.orgId);
                        await fetchProjectDetailsByOrgArray(orgIdArray);
                        intervalId = setInterval(() => {
                            fetchProjectDetailsByOrgArray(orgIdArray);
                        }, 5000);
                    } else if (selectedOrg === realm) {
                        await fetchProjectData(realm);
                        intervalId = setInterval(() => {
                            fetchProjectData(realm);
                        }, 5000);
                    } else{
                        await fetchDeployedProjectData(selectedOrg);
                        intervalId = setInterval(() => {
                            fetchDeployedProjectData(selectedOrg);
                        }, 5000);
                    }
                } else {
                    await fetchProjectData();
                    intervalId = setInterval(() => {
                        console.log('Interval fetch running...');
                        fetchProjectData();
                    }, 5000);
                }
            } catch (error) {
                console.error('Failed to fetch data:', error);
                setIsLoading(false); // Ensure loading stops on error
            } finally {
                // Clear the timeout since we completed successfully
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            }

        };

        fetchData();
        // Clean up the interval and timeout on component unmount
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };

    }, [isEnablerSuperAdmin, selectedOrg]);

    const handleOrgChange = (orgId) => {
        console.log('Organization changed to:', orgId);
        setSelectedOrg(orgId);
        setPage(0);
        setIsLoading(true);

        // Add timeout for org change as well
        const timeoutId = setTimeout(() => {
            console.log('Org change loading timeout, forcing isLoading to false');
            setIsLoading(false);
        }, 10000);

        if (orgId === 'all') {
            setOrgName("Network");
            fetchProjectDetailsByOrgArray(subOrganizations.map(org => org.orgId)).finally(() => {
                clearTimeout(timeoutId);
            });
        } else if (orgId === realm) {
            setOrgName(getOrgNameById(orgId));
            fetchProjectData(orgId).finally(() => {
                clearTimeout(timeoutId);
            });
        }
        else {
            setOrgName(getOrgNameById(orgId));
            fetchDeployedProjectData(orgId).finally(() => {
                clearTimeout(timeoutId);
            });
        }
    };

    const fetchProjectData = async (orgId = null) => {
        try {
            console.log('fetchProjectData called, orgId:', orgId);
            const groupName = isEnablerSuperAdmin ? orgId : await getGroupName();
            if (!isEnablerSuperAdmin) {
                const orgName = await OrgRepository.getOrgDetailsById(groupName);
                setOrgName(orgName.data.orgName);
            }
            else {
                setOrgName(getOrgNameById(groupName));
            }

            const response = await ProjectRepository.getProjectDetailsByOrgId(groupName);
            // Handle both response structures: { data: { projects: [...] } } or { data: [...] }
            const projects = Array.isArray(response.data?.projects)
                ? response.data.projects
                : (Array.isArray(response.data) ? response.data : []);
            console.log('Projects fetched:', projects.length, 'projects');
            setProjectData(projects);
        }
        catch (error) {
            console.log(`error is ${error}`);
            console.error('Failed to fetch project data:',);
        } finally {
            console.log('fetchProjectData completed, setting isLoading to false');
            setIsLoading(false);
        }
    };

    const fetchDeployedProjectData = async (orgId) => {
        try {
            // Set the organization name for the selected org
            setOrgName(getOrgNameById(orgId));
            const response = await ProjectRepository.getDeployedProjectDetails(orgId);
            setProjectData(response.data);
        }
        catch (error) {
            console.error('Failed to fetch deployed project data:', error);
        } finally {
            setIsLoading(false);
        }
    }

    const getGroupName = async () => {
        try {
            const groupName = keycloak.tokenParsed.groups[0].split('/').pop();
            return groupName;
        }
        catch {
            console.error('Failed to fetch group name:',);
        }
    }

    const getOrgNameById = (orgId) => {
        const org = subOrganizations.find(subOrg => subOrg.orgId === orgId);
        return org ? org.orgName : 'Unknown Organization';
    };

    const getDropdownTitle = () => {
        if (selectedOrg === 'all') {
            return 'All Organizations';
        } else if (selectedOrg === realm) {
            return getOrgNameById(selectedOrg);
        } else {
            return getOrgNameById(selectedOrg);
        }
    };

    const getPageTitle = () => {
        if (selectedOrg === 'all') {
            return 'Network';
        } else if (selectedOrg === realm) {
            return getOrgNameById(selectedOrg);
        } else {
            return getOrgNameById(selectedOrg);
        }
    };

    const fetchProjectDetailsByOrgArray = async (orgIdArray) => {
        try {
            console.log('fetchProjectDetailsByOrgArray called, orgArray:', orgIdArray);
            setOrgName("Network")
            const formattedOrgIdArray = orgIdArray.map(orgId => ({
                orgName: orgId,
                orgType: realm === orgId ? "rootOrg" : "subOrg"
            }));
            const response = await ProjectRepository.getProjectDetailsByOrgArray({ orgIds: formattedOrgIdArray });
            const projectData = response.data;
            console.log('Projects fetched by org array:', projectData?.length || 0, 'projects');
            setProjectData(projectData);
        } catch (error) {
            console.error('Failed to fetch project details by org array:', error);
        } finally {
            console.log('fetchProjectDetailsByOrgArray completed, setting isLoading to false');
            setIsLoading(false);
        }
    };


    const submitReg = () => {
        if (regPage.current) {
            regPage.current.handleSubmit();
        }
    };

    const handleEdit = (currentProject) => {
        if (isActionDisabledMemo(currentProject)) return;
        setVisible(true);
        setCurrentProject(currentProject);
        const project_id = currentProject.project_id;
        navigate(`/wizard/${project_id}`);
    }

    const viewProject = (currentProject) => {
        navigate(`/viewData/${currentProject}`);
    }
    const updateProject = async (currentProjectId, status) => {
        const orgId = isEnablerSuperAdmin ? selectedOrg || realm : await getGroupName();
        ProjectRepository.updateProject({ status: status }, currentProjectId)
            .then((result) => {
                console.log("Project update successful on frontend:", result);
                fetchProjectData(orgId);
                setdeployModal(false);
                setdisableModal(false);
                setExportModal(false);
                setundeployModal(false);
            })
            .catch(error => {
                console.error('Failed to update project:', error);
            });
    }

    const QrCallback = (QRCode) => {
        ProjectRepository.getQrCode({ qrcodePath: QRCode }).then((response) => {
            setSignedQRCode(response.presignedURL);
        }).catch((error) => {
            console.log("QR Code error", error);
        })
    }

    const generateUniqueCode = () => {
        return shortid.generate();;
    };

    const exportToExcel = async (currentProjectId) => {
        setExportModal(false)
        try {
            const response = await ProjectRepository.getProjectDetailsById(currentProjectId);
            const projectDetails = response.data[0];
            const formattedData = [];
            const choicesData = [];
            projectDetails.questions.map(question => {
                let name = question.q_text.replace(/ /g, '_'); // Replace spaces with underscores
                let type = "";
                if (question.q_type === "Descriptive") {
                    type = "text";
                } else if (question.q_type === "Multiple Choice") {
                    const uniqueCode = generateUniqueCode();
                    type = "select_one " + uniqueCode;
                    question.options.forEach((option, index) => {
                        let optName = option.replace(/ /g, '_'); // Replace spaces with underscores
                        choicesData.push({
                            list_name: uniqueCode,
                            name: optName,
                            label: option
                        });
                    });
                } else if (question.q_type === "Location") {
                    type = "location"
                }
                formattedData.push({
                    type: type,
                    name: name,
                    label: question.q_text,
                    required: false
                });
            });

            // Convert data to Excel sheet
            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const worksheetChoices = XLSX.utils.json_to_sheet(choicesData);


            // Create a new Excel workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'survey');
            XLSX.utils.book_append_sheet(workbook, worksheetChoices, 'choices');

            // Save the Excel file
            XLSX.writeFile(workbook, `${projectDetails.name}_details.xlsx`);
        } catch (error) {
            console.error('Failed to export to Excel:', error);
        }
    }

    const deleteProject = async (project_id) => {
        setDeleteModal(false)
        ProjectRepository.deleteProject(project_id).then(() => {
            fetchProjectData();
        }).catch((error) => {
            console.error('Failed to delete project:', error);
        });
    }

    const hasRequiredTemplateMessages = (project) => {
        if (!Array.isArray(project?.template_messages)) {
            return false;
        }

        const hasFirstMessage = project.template_messages.some((message) => message.message_type === "first");
        const hasLastMessage = project.template_messages.some((message) => message.message_type === "last");
        return hasFirstMessage && hasLastMessage;
    };

    const checkQuestions = async (project_id) => {
        const project = projectData.find(p => p.project_id === project_id);
        if (isActionDisabledMemo(project)) return; // Prevent action if disabled    

        if (!project.questions || project.questions.length === 0) {
            setModalTitle("No Questions");
            setModalMessage("You must add at least one question before deploying this project.");
            setnoQuesModal(true);
            return;
        }

        projectData.map((project) => {
            if (project.project_id === project_id) {
                const hasTemplateMessages = hasRequiredTemplateMessages(project);

                if (!project.questions && !hasTemplateMessages) {
                    setModalTitle("Missing Questions and Template Messages");
                    setModalMessage("There are no questions and the required template messages (first or last) are missing. Please add them before deploying.");
                    setnoQuesModal(true);
                } else if (!project.questions) {
                    setModalTitle("No Questions");
                    setModalMessage("There are no questions in this project. Please add questions before deploying.");
                    setnoQuesModal(true);
                } else if (!hasTemplateMessages) {
                    setModalTitle("Missing Template Messages");
                    setModalMessage("The required template messages (first or last) are missing. Please add them before deploying.");
                    setnoQuesModal(true);
                } else {
                    setdeployModal(!deployModal);
                }
            }
        });
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });

        const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
        });

        return `${formattedDate}`;
    };


    const filteredProjects = projectData.filter((project) =>
        project.name?.toLowerCase().includes(search?.toLowerCase()) ||
        project.description?.toLowerCase().includes(search?.toLowerCase()) ||
        project.status?.toLowerCase().includes(search?.toLowerCase()) ||
        project.group_name?.toLowerCase().includes(search?.toLowerCase()) ||
        formatDateTime(project.updatedAt)?.toLowerCase().includes(search?.toLowerCase())
    );

    const sortedProjects = filteredProjects.sort((a, b) => {
        if (orderBy === 'name') {
            return order === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        }
        if (orderBy === 'updatedAt') {
            return order === 'asc' ? new Date(a.updatedAt) - new Date(b.updatedAt) : new Date(b.updatedAt) - new Date(a.updatedAt);
        }
        if (orderBy === 'responses_count') {
            return order === 'asc' ? a.responses_count - b.responses_count : b.responses_count - a.responses_count;
        }
        if (orderBy === 'status') {
            return order === 'asc' ? a.status.localeCompare(b.status) : b.status.localeCompare(a.status);
        }
        if (orderBy === 'group_name') {
            return order === 'asc' ? a.group_name.localeCompare(b.group_name) : b.group_name.localeCompare(a.group_name);
        }
        return 0;
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const copyToClipboard = (QRCodeText) => {
        const message = QRCodeText.replace(/\s+$/, '');
        // When the QR code text ends with '.', append '+' so the link works on iOS and WhatsApp shows it with + at the end
        const endsWithDot = message.endsWith('.');
        const alreadyHasPlus = message.endsWith('.+');
        const appendPlus = endsWithDot || alreadyHasPlus;
        const base = alreadyHasPlus ? message.slice(0, -1) : message; // text before the trailing '+'
        const encodedText = appendPlus && base.endsWith('.')
            ? encodeURIComponent(base) + '+'   // literal '+' in URL so copied link ends with + and works on iOS
            : encodeURIComponent(message);

        const whatsappUrl = `https://wa.me/+917483950284?text=${encodedText}`;
        navigator.clipboard.writeText(whatsappUrl).then(() => {
            setLinkCopied(true);
            setTimeout(() => {
                setLinkCopied(false);
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy link: ', err);
            window.open(whatsappUrl, '_blank');
        });
    }


    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = event => {
        setSearch(event.target.value);
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        setPage(0);
    };

    const notify = (message) => toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    const notifyInfo = (message) => toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });

    const customTheme = (outerTheme) =>
        createTheme({
            palette: {
                mode: outerTheme.palette.mode,
            },
            components: {
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            '--TextField-brandBorderColor': '#fff',
                            '--TextField-brandBorderHoverColor': '#fff',
                            '--TextField-brandBorderFocusedColor': '#fff',
                            '& label': {
                                color: '#fcaf17',
                            },
                            '& label.Mui-focused': {
                                color: '#fcaf17',
                                fontSize: 20
                            },
                        },
                    },
                },

                // MuiFilledInput: {
                //   styleOverrides: {
                //     root: {
                //       '&::before, &::after': {
                //         borderBottom: '2px solid var(--TextField-brandBorderColor)',
                //       },
                //       '&:hover:not(.Mui-disabled, .Mui-error):before': {
                //         borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',
                //       },
                //       '&.Mui-focused:after': {
                //         borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',
                //       },
                //     },
                //   },
                // },
                MuiInput: {
                    styleOverrides: {
                        root: {
                            '&::before': {
                                borderBottom: '2px solid var(--TextField-brandBorderColor)',
                            },
                            '&:hover:not(.Mui-disabled, .Mui-error):before': {
                                borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',
                            },
                            '&.Mui-focused:after': {
                                borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',
                                // color:'#fff',
                                backgroundColor: '#252525'
                            },
                            '&.Mui-focused': {
                                backgroundColor: '#252525 !important',
                                caretColor: '#d9d9d9 !important',
                                boxShadow: '0 0 #00800033 !important',
                                padding: '0 1rem !important',
                                color: '#d9d9d9 !important'
                            },
                            color: ' #d9d9d9 !important'
                        },
                    },
                },
            },
        });


    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#252525",
            border: '1px solid var(--secondary-dark-bg)',
            //   color: theme.palette.common.white,
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: "150%",
            color: '#d9d9d9',
            fontFamily: 'Poppins',
            '::hover': {
                color: '#d9d9d9',
            }

        },

        [`&.${tableCellClasses.body}`]: {
            fontSize: 16,
            fontStyle: 'normal',
            border: '1px solid var(--secondary-dark-bg)',
            fontWeight: 300,
            fontSize: '16px',
            color: '#d9d9d9',
            fontFamily: 'Poppins',
            backgroundColor: "#252525",
        }

    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type': {
            backgroundColor: '#252525',
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            // border: 0,
        },
    }));

    const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
        // backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.common.white,
        '&:MuiTablePagination-root': {
            backgroundColor: '#252525',
            color: '#d9d9d9',
        },
        [`&.${tablePaginationClasses.root}`]: {
            backgroundColor: '#252525',
            color: '#d9d9d9',
        }
    }));

    const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({

        [`&.${tableSortLabelClasses.root}`]: {
            color: '#d9d9d9',
            '& .MuiTableSortLabel-icon': {
                opacity: 1,
                color: '#d9d9d9',
            },
        },
        [`&.${tableSortLabelClasses.icon}`]: {
            color: '#d9d9d9',
            fill: '#d9d9d9'
        },
        '&:MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
            color: '#d9d9d9 !important',
            fill: '#d9d9d9'
        },
        [`&.${tableSortLabelClasses.iconDirectionAsc}`]: {
            color: '#d9d9d9',
            fill: '#d9d9d9'
        },
        [`&.${tableSortLabelClasses.iconDirectionDesc}`]: {
            color: '#d9d9d9',
            fill: '#d9d9d9'
        },
        [`&.${tableSortLabelClasses.root}.${tableSortLabelClasses.active}, .${tableSortLabelClasses.icon}`]: {
            color: '#d9d9d9 !important',
            fill: '#d9d9d9 !important'
        },
    }));

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '85vh',
                gap: '1.5rem'
            }}>
                <CSpinner className='spinner' size="lg" />
                <div style={{ textAlign: 'center' }}>
                    <h2 className='textcolor' style={{
                        fontSize: '1.4rem',
                        fontWeight: '400',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        letterSpacing: '0.5px',
                        margin: 0
                    }}>
                        Loading Projects...
                    </h2>
                </div>
            </div>
        );
    }

    if (projectData?.length === 0) {

        return (
            <>
                <div>
                </div>
                <div className='mainHeaderDiv mb-2' style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h3 className='mainTitle'><span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{getPageTitle()}</span> Projects</h3>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexDirection: 'row' }}>
                            {isEnablerSuperAdmin && (
                                <div style={{ marginLeft: '1rem' }}>
                                    <CDropdown>
                                        <CDropdownToggle className='selectOrg' style={{ backgroundColor: "#fcaf17", color: 'black' }}>
                                            {getDropdownTitle()} <FaCaretDown />
                                        </CDropdownToggle>
                                        <CDropdownMenu>
                                            <CDropdownItem key="all" onClick={() => handleOrgChange('all')}>
                                                All Organizations
                                            </CDropdownItem>
                                            <hr style={{ margin: '0.5rem 0' }} />
                                            <CDropdownItem key="parent" onClick={() => handleOrgChange(realm)}>
                                                {getOrgNameById(realm)}
                                            </CDropdownItem>
                                            {subOrganizations.filter(org => org.orgId !== realm).map((org) => (
                                                <CDropdownItem key={org.id} onClick={() => handleOrgChange(org.orgId)}>
                                                    {org.orgName}
                                                </CDropdownItem>
                                            ))}
                                        </CDropdownMenu>
                                    </CDropdown>
                                </div>
                            )}
                            {!isCreateButtonDisabled && (
                                <div style={{ marginLeft: '0.4rem' }}>
                                    <CButton onClick={() => setCreateModal(true)} style={{ backgroundColor: "#fcaf17", color: 'black' }}>
                                        + Create New Project
                                    </CButton>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="noDataPage" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '70vh', marginTop: '-5vh' }}>
                    <div style={{ textAlign: 'center' }}>
                        <h2 className='textcolor' style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>No Projects Available</h2>
                        <p className='textcolor' style={{ fontSize: '0.9rem', opacity: '0.8' }}>Please create a new project to get started.</p>
                    </div>
                </div>
                <CModal
                    visible={createModal}
                    onClose={() => setCreateModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>Create Project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <Registration setCreateModal={setCreateModal} ref={regPage}></Registration>
                    </CModalBody>
                    {/* <CModalFooter>
                        <CButton color="secondary" onClick={() => setCreateModal(false)}>
                            Close
                        </CButton>
                        <CButton onClick={submitReg} style={{ width: '10rem' }}>Create Project{regPage.current && regPage.current.loading ? <CSpinner color="secondary" /> : ''}</CButton>
                    </CModalFooter> */}
                </CModal>
            </>
        );
    } else {
        return (
            <div>
                <div>
                </div>
                {projectData.length > 0 && (
                    <div className='mainHeaderDiv mb-2' style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                            <h3 className='mainTitle'><span style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{getPageTitle()}</span> Projects</h3>
                        </div>
                        <div className='searchCreate' >
                            <div style={{ width: "15rem" }}>
                                <ThemeProvider theme={customTheme(outerTheme)}>

                                    <TextField
                                        fullWidth
                                        label="Search Projects"
                                        variant="standard"
                                        color=""
                                        onChange={handleSearchChange}
                                        sx={{ m: 1 }}
                                    />
                                </ThemeProvider>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexDirection: 'row', marginLeft: '1.5rem' }}>
                                {isEnablerSuperAdmin && (
                                    <div style={{ marginLeft: '1rem' }}>
                                        <CDropdown>
                                            <CDropdownToggle className='selectOrg' style={{ backgroundColor: "#fcaf17", color: 'black' }}>
                                                {getDropdownTitle()} <FaCaretDown />
                                            </CDropdownToggle>

                                            <CDropdownMenu>
                                                <CDropdownItem key="all" onClick={() => handleOrgChange('all')}>
                                                    All Organizations
                                                </CDropdownItem>
                                                <hr style={{ margin: '0.5rem 0' }} />
                                                <CDropdownItem key="parent" onClick={() => handleOrgChange(realm)}>
                                                    {getOrgNameById(realm)}
                                                </CDropdownItem>
                                                {subOrganizations.filter(org => org.orgId !== realm).map((org) => (
                                                    <CDropdownItem key={org.id} onClick={() => handleOrgChange(org.orgId)}>
                                                        {org.orgName}
                                                    </CDropdownItem>
                                                ))}
                                            </CDropdownMenu>
                                        </CDropdown>
                                    </div>
                                )}
                                <div style={{ display: 'flex', marginLeft: '0.5rem' }}>
                                    {!isCreateButtonDisabled && (
                                        <CButton onClick={() => setCreateModal(true)} style={{ backgroundColor: "#fcaf17", color: 'black' }}>
                                            + Create New Project
                                        </CButton>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                )}
                {/* <p>This is my new component content.</p> */}
                <Paper sx={{ width: '100%', overflow: 'hidden', height: '100%' }} >
                    <TableContainer style={{ minHeight: '20rem', backgroundColor: 'var(--primary-dark-bg)' }} >
                        <Table >
                            <TableHead >
                                <TableRow >
                                    <StyledTableCell>
                                        Sl No
                                    </StyledTableCell>
                                    <StyledTableCell >
                                        <StyledTableSortLabel
                                            active={orderBy === 'name'}
                                            direction={orderBy === 'name' ? order : 'asc'}
                                            onClick={() => handleRequestSort('name')}
                                        >
                                            Project Name
                                        </StyledTableSortLabel>
                                    </StyledTableCell>
                                    {isEnablerSuperAdmin && (
                                        <StyledTableCell>
                                            <StyledTableSortLabel
                                                active={orderBy === 'group_name'}
                                                direction={orderBy === 'group_name' ? order : 'asc'}
                                                onClick={() => handleRequestSort('group_name')}
                                            >
                                                Organization Name    </StyledTableSortLabel>
                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>
                                        <StyledTableSortLabel
                                            active={orderBy === 'updatedAt'}
                                            direction={orderBy === 'updatedAt' ? order : 'asc'}
                                            onClick={() => handleRequestSort('updatedAt')}
                                        >
                                            Last Modified
                                        </StyledTableSortLabel>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <StyledTableSortLabel
                                            active={orderBy === 'responses_count'}
                                            direction={orderBy === 'responses_count' ? order : 'asc'}
                                            onClick={() => handleRequestSort('responses_count')}
                                        >
                                            Responses Count
                                        </StyledTableSortLabel>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <StyledTableSortLabel
                                            active={orderBy === 'status'}
                                            direction={orderBy === 'status' ? order : 'asc'}
                                            onClick={() => handleRequestSort('status')}
                                        >
                                            Status
                                        </StyledTableSortLabel>
                                    </StyledTableCell>
                                    {!(isOrgViewer || isAssessmentManager) && (
                                        <StyledTableCell>Actions</StyledTableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sortedProjects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((project, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell>{page * rowsPerPage + index + 1}</StyledTableCell>
                                        <StyledTableCell style={{ width: '20rem' }}>
                                            <CTooltip placement="top" content="View Project">
                                                <Link className='text-link' to={`/viewData/${project.project_id}`}>
                                                    {project.name}
                                                </Link>
                                            </CTooltip>
                                        </StyledTableCell>
                                        {isEnablerSuperAdmin && (
                                            <StyledTableCell>
                                                {getOrgNameById(project.group_name)}                                        </StyledTableCell>
                                        )}
                                        {/* <StyledTableCell>{project.description}</StyledTableCell> */}
                                        <StyledTableCell className='dateCell'>
                                            {formatDateTime(project.updatedAt)}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {project.responses_count !== undefined && project.responses_count > 0 ?
                                                (
                                                    <CTooltip placement="top" content="view responses">
                                                        <Link className='text-link' to={`/summary/${project.project_id}/${encodeURIComponent(project.name)}`}>
                                                            {project.responses_count}
                                                        </Link>
                                                    </CTooltip>
                                                ) :
                                                (
                                                    // <Link className='text-link'>
                                                    0
                                                    // </Link>
                                                )
                                            }
                                        </StyledTableCell>
                                        <StyledTableCell style={{ width: '12rem' }}>
                                            {(project.status?.toLowerCase() === 'failed' && project.failure_reason?.startsWith('OPTION_CHAR_LIMIT')) ? (
                                                <CTooltip content={formatFailureTooltip(project.failure_reason)} placement="top">
                                                    <CBadge className='badgeSpan' color="danger" style={{ cursor: 'pointer' }}>
                                                        {project.status}
                                                    </CBadge>
                                                </CTooltip>
                                            ) : (
                                                <CBadge className='badgeSpan' color={getBadge(project.status)}>
                                                    {project.status}
                                                </CBadge>
                                            )}
                                        </StyledTableCell>
                                        {!(isOrgViewer || isAssessmentManager) && (
                                            <StyledTableCell style={{ width: '9rem' }}>
                                                {/* <IconButton onClick={() => handleOpenEditModal(project)}>
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton onClick={() => handleOpenUploadModal(project)}>
                                            <CloudUploadIcon />cilCalendar
                                        </IconButton> */}
                                                {/* 
                                        <CIcon icon={cilCloudUpload} onClick={() => { checkQuestions(project.project_id); setCurrentProjectId(project.project_id) }} style={{ cursor: "pointer" }} /> */}
                                                <div className='flexRow' style={{ float: 'right' }}>
                                                    <div className='iconClass'>
                                                        {project.status?.toLowerCase() === 'draft' && (
                                                            <>
                                                                <CTooltip placement="top" content="Edit Project">
                                                                    <CIcon
                                                                        icon={cilPencil}
                                                                        onClick={() => handleEdit(project)}
                                                                        style={{ cursor: isActionDisabledMemo(project) ? "not-allowed" : "pointer" }}
                                                                        disabled={isActionDisabledMemo(project)}
                                                                    />
                                                                </CTooltip>
                                                                <CTooltip placement="top" content={(!project.questions || project.questions.length === 0) ? "Upload questions to deploy the project" : (!hasRequiredTemplateMessages(project) ? "Configure first and last template messages to deploy" : "Deploy Project")}>
                                                                    {/* <CIcon
                                                                    icon={cilCloudUpload}
                                                                    onClick={() => { checkQuestions(project.project_id); setCurrentProjectId(project.project_id); }}
                                                                    style={{ cursor: "pointer" }}
                                                                /> */}
                                                                    <div onClick={() => {
                                                                        if (project.questions && project.questions.length > 0 && hasRequiredTemplateMessages(project) && !isActionDisabledMemo(project)) {
                                                                            setCurrentProjectId(project.project_id);
                                                                            checkQuestions(project.project_id);
                                                                        }
                                                                    }}

                                                                        style={{
                                                                            cursor: (!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project) || isActionDisabledMemo(project)) ? "not-allowed" : "pointer",
                                                                            opacity: (!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project)) ? 0.5 : 1
                                                                        }}
                                                                        className='deployDiv'
                                                                        disabled={!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project) || isActionDisabledMemo(project)}
                                                                    >
                                                                        <GrDeploy style={{ color: 'white' }} />
                                                                    </div>
                                                                </CTooltip>
                                                            </>

                                                        )}
                                                        {project.status?.toLowerCase() === 'failed' && project.failure_reason?.startsWith('OPTION_CHAR_LIMIT') && (
                                                            <>
                                                                <CTooltip placement="top" content="Edit Project">
                                                                    <CIcon
                                                                        icon={cilPencil}
                                                                        onClick={() => handleEdit(project)}
                                                                        style={{ cursor: isActionDisabledMemo(project) ? "not-allowed" : "pointer" }}
                                                                        disabled={isActionDisabledMemo(project)}
                                                                    />
                                                                </CTooltip>
                                                                <CTooltip placement="top" content={(!project.questions || project.questions.length === 0) ? "Upload questions to deploy the project" : (!hasRequiredTemplateMessages(project) ? "Configure first and last template messages to deploy" : "Deploy Project")}>
                                                                    <div onClick={() => {
                                                                        if (project.questions && project.questions.length > 0 && hasRequiredTemplateMessages(project) && !isActionDisabledMemo(project)) {
                                                                            setCurrentProjectId(project.project_id);
                                                                            checkQuestions(project.project_id);
                                                                        }
                                                                    }}
                                                                        style={{
                                                                            cursor: (!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project) || isActionDisabledMemo(project)) ? "not-allowed" : "pointer",
                                                                            opacity: (!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project)) ? 0.5 : 1
                                                                        }}
                                                                        className='deployDiv'
                                                                        disabled={!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project) || isActionDisabledMemo(project)}
                                                                    >
                                                                        <GrDeploy style={{ color: 'white' }} />
                                                                    </div>
                                                                </CTooltip>
                                                            </>
                                                        )}
                                                        {project.status?.toLowerCase() === 'deployed' && (
                                                            <>
                                                                <CTooltip placement="top" content="Undeploy Project">
                                                                    <CIcon
                                                                        icon={cilActionUndo}
                                                                        onClick={() => handleIconClick('undeploy', project)}
                                                                        style={{ cursor: isActionDisabledMemo(project) ? "not-allowed" : "pointer" }}
                                                                    />
                                                                </CTooltip>
                                                                <CTooltip placement="top" content="Show QR Code">
                                                                    <CIcon
                                                                        icon={cilQrCode}
                                                                        onClick={() => handleIconClick('showQRCode', project)}
                                                                        style={{ cursor: isActionDisabledMemo(project) ? "not-allowed" : "pointer" }}
                                                                        disabled={isActionDisabledMemo(project)}
                                                                    />
                                                                </CTooltip>
                                                            </>
                                                        )}
                                                        {project.status?.toLowerCase() === 'undeployed' && (
                                                            <>
                                                                <CTooltip placement="top" content="Edit Project">
                                                                    <CIcon
                                                                        icon={cilPencil}
                                                                        onClick={() => handleEdit(project)}
                                                                        style={{ cursor: isActionDisabledMemo(project) ? "not-allowed" : "pointer" }}
                                                                        disabled={isActionDisabledMemo(project)}
                                                                    />
                                                                </CTooltip>
                                                                <CTooltip placement="top" content={(!project.questions || project.questions.length === 0) ? "Upload questions to deploy the project" : (!hasRequiredTemplateMessages(project) ? "Configure first and last template messages to deploy" : "Deploy Project")}>
                                                                    {/* <CIcon
                                                                    icon={cilCloudUpload}
                                                                    onClick={() => { checkQuestions(project.project_id); setCurrentProjectId(project.project_id); }}
                                                                    style={{ cursor: "pointer" }}
                                                                /> */}
                                                                    <div onClick={() => {
                                                                        if (project.questions && project.questions.length > 0 && hasRequiredTemplateMessages(project) && !isActionDisabledMemo(project)) {
                                                                            setCurrentProjectId(project.project_id);
                                                                            checkQuestions(project.project_id);
                                                                        }
                                                                    }}
                                                                        style={{
                                                                            cursor: (!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project) || isActionDisabledMemo(project)) ? "not-allowed" : "pointer",
                                                                            opacity: (!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project)) ? 0.5 : 1
                                                                        }}
                                                                        className='deployDiv'
                                                                        disabled={!project.questions || project.questions.length === 0 || !hasRequiredTemplateMessages(project) || isActionDisabledMemo(project)}
                                                                    >
                                                                        <GrDeploy />
                                                                    </div>
                                                                </CTooltip>
                                                            </>
                                                        )}
                                                        <CDropdown>
                                                            {(project.status?.toLowerCase() !== 'deploying') && (
                                                                <CDropdownToggle className='nameTag userTag dropDown dropdown-toggleClass' color="info" disabled={project.status?.toLowerCase() === 'draft' && isProjectManager}>
                                                                    <IoEllipsisVerticalSharp style={{ cursor: "pointer", width: '1.3rem', height: '1.3rem', color: 'white' }} />
                                                                    {/* <IoEllipsisVerticalSharp
                                                                            style={{
                                                                                cursor: project.status?.toLowerCase() === 'draft' && isProjectManager ? 'not-allowed' : 'pointer',
                                                                                width: '1.3rem',
                                                                                height: '1.3rem',
                                                                                color: 'white'
                                                                            }}
                                                                        /> */}
                                                                </CDropdownToggle>
                                                            )}
                                                            <CDropdownMenu>
                                                                {project.status?.toLowerCase() === 'deployed' && (
                                                                    <>
                                                                        <CDropdownItem icon={cilDataTransferUp} className='dropdownIconItem' onClick={() => handleIconClick('export', project)} style={{ cursor: "pointer" }}>
                                                                            <PiExportBold style={{ cursor: "pointer", width: '1.3rem', height: '1.3rem', color: 'white' }} />
                                                                            Export</CDropdownItem>
                                                                        <CDropdownItem onClick={() => handleIconClick('close', project)} className='dropdownIconItem'>
                                                                            <CIcon
                                                                                icon={cilBan}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                            Close
                                                                        </CDropdownItem>
                                                                    </>
                                                                )}
                                                                {(project.status?.toLowerCase() === 'undeployed' || project.status?.toLowerCase() === 'closed') && (
                                                                    <>
                                                                        <CDropdownItem className='dropdownIconItem' onClick={() => handleIconClick('export', project)} style={{ cursor: "pointer" }}>
                                                                            <img src={excelIcon} style={{ cursor: "pointer", width: '1.3rem', height: '1.3rem' }} />
                                                                            Export
                                                                        </CDropdownItem>
                                                                    </>
                                                                )}
                                                                {!isProjectManager && (
                                                                    <CDropdownItem icon={cilBan} className='dropdownIconItem' onClick={() => handleIconClick('delete', project)} style={{ cursor: "pointer" }}>
                                                                        <CIcon
                                                                            icon={cilTrash}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                        Delete
                                                                    </CDropdownItem>
                                                                )}
                                                            </CDropdownMenu>
                                                        </CDropdown>
                                                    </div>
                                                </div>

                                            </StyledTableCell>
                                        )}
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <StyledTablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={filteredProjects?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
                <CModal
                    visible={visible}
                    onClose={() => setVisible(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader onClose={() => setVisible(false)}>
                        <CModalTitle id="LiveDemoExampleLabel">Edit Project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to edit this project?</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setVisible(false)} className=''>
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => handleEdit(currentProject)}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={deleteModal}
                    onClose={() => setDeleteModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader onClose={() => setDeleteModal(false)}>
                        <CModalTitle id="LiveDemoExampleLabel">Delete Project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to delete this project?</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setDeleteModal(false)}>
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => deleteProject(currentProjectId)}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={deployModal}
                    onClose={() => setdeployModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader onClose={() => setdeployModal(false)}>
                        <CModalTitle id="LiveDemoExampleLabel">Deploy project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to deploy this project?
                        </p><br />
                        <p>*Note: You can still add languages after deploying</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setdeployModal(false)}>
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => updateProject(currentProjectId, "DEPLOYING")}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={noQuesModal}
                    onClose={() => setnoQuesModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader onClose={() => setnoQuesModal(false)}>
                        <CModalTitle id="LiveDemoExampleLabel">
                            {modalTitle}
                        </CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>{modalMessage}</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setnoQuesModal(false)}>
                            Close
                        </CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={disableModal}
                    onClose={() => setdisableModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>Close Project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to close this project?</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setdisableModal(false)}>
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => updateProject(currentProjectId, "DISABLED")}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={exportModal}
                    onClose={() => setExportModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>Export project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to export this project?</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setExportModal(false)}>
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => exportToExcel(currentProjectId)}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={undeployModal}
                    onClose={() => setundeployModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>Undeploy project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to undeploy this project?</p>
                        <p>*Note: You can only add or remove languages after undeploying.</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setundeployModal(false)}>
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => updateProject(currentProjectId, "UNDEPLOYED")}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={QRModal}
                    onClose={() => { setQRModal(false); setSignedQRCode(null); setLinkCopied(false); }}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>WhatsApp QR Code</CModalTitle>
                    </CModalHeader>
                    <CModalBody className='d-flex flex-column align-items-center gap-3'>
                        <p style={{ color: 'var(--secondary)', fontSize: '14px', textAlign: 'center' }}>
                            Scan the QR code below to start a WhatsApp conversation with our support team.
                            The message will be pre-filled with your project details for faster assistance.
                        </p>

                        <div className="d-flex justify-content-center">
                            {signedQRCode === null ? (
                                <div 
                                    style={{
                                        width: "280px",
                                        height: "280px",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "8px",
                                        padding: "16px",
                                        backgroundColor: "#f8f9fa",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative",
                                        overflow: "hidden"
                                    }}
                                >
                                    <div 
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            backgroundColor: "#e9ecef",
                                            borderRadius: "4px",
                                            position: "relative",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <div 
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: "-100%",
                                                width: "100%",
                                                height: "100%",
                                                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                                                animation: "skeleton-loading 1.5s infinite"
                                            }}
                                        />
                                    </div>
                                    <small 
                                        style={{ 
                                            position: "absolute",
                                            bottom: "-30px",
                                            color: '#6c757d',
                                            fontSize: "12px"
                                        }}
                                    >
                                        Loading QR Code...
                                    </small>
                                </div>
                            ) : (
                                <img
                                    style={{
                                        width: "280px",
                                        height: "280px",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "8px",
                                        padding: "16px",
                                        backgroundColor: "#fff"
                                    }}
                                    src={signedQRCode}
                                    alt="WhatsApp QR Code"
                                />
                            )}
                        </div>

                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div style={{ 
                                flex: 1, 
                                height: '1px', 
                                backgroundColor: '#dee2e6',
                                margin: '0'
                            }}></div>
                            <span style={{
                                padding: '0 16px',
                                color: '#6c757d',
                                fontSize: '14px',
                                fontWeight: '500',
                                whiteSpace: 'nowrap'
                            }}>
                                or
                            </span>
                            <div style={{ 
                                flex: 1, 
                                height: '1px', 
                                backgroundColor: '#dee2e6',
                                margin: '0'
                            }}></div>
                        </div>

                        <CButton
                            color={linkCopied ? "success" : "success"}
                            variant={linkCopied ? "solid" : "outline"}
                            size="lg"
                            className="w-100"
                            style={{
                                borderColor: linkCopied ? '#28a745' : '#fcaf17',
                                backgroundColor: linkCopied ? '#28a745' : '#fcaf17',
                                color: '#000',
                                fontSize: '16px',
                                fontWeight: '500',
                                transition: 'all 0.3s ease'
                            }}
                            onClick={() => copyToClipboard(QRCodeText)}
                            disabled={linkCopied}
                        >
                            {linkCopied ? 'Link Copied!' : 'Click to Share Link'}
                        </CButton>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => { setQRModal(false); setSignedQRCode(null); setLinkCopied(false); }}>
                            Close
                        </CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={ViewModal}
                    onClose={() => setViewModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>View Project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>Are you sure you want to view this project?</p>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => setViewModal(false)} >
                            Close
                        </CButton>
                        <CButton color="primary" onClick={() => { viewProject(currentProjectId) }}>Yes</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    visible={createModal}
                    onClose={() => setCreateModal(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <CModalHeader>
                        <CModalTitle>Create Project</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <Registration setCreateModal={setCreateModal} ref={regPage}></Registration>
                    </CModalBody>
                    {/* <CModalFooter>
                        <CButton color="secondary" onClick={() => setCreateModal(false)}>
                            Close
                        </CButton>
                        <CButton onClick={submitReg} style={{ width: '10rem' }}>Create Project{regPage.current && regPage.current.loading ? <CSpinner color="secondary" /> : ''}</CButton>
                    </CModalFooter> */}
                </CModal>
            </div>
        );
    }
}

export default DataCollectorComponent;